import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import VideoQuestionnaire from './components/VideoQuestionnaire';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<VideoQuestionnaire />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;